// src/config.js

// для розробки
const API_BASE_URL = "https://delicate-example-d5e54b2a67.strapiapp.com";

// для продакшена (потім просто розкоментуєш та поміняєш)
// const API_BASE_URL = "https://my-backend.com";

export { API_BASE_URL };

